import styles from './holidayPromo.module.css'

export default function HolidayPromo() {
  const becomeATourMaster = () => {
    window.location.href = '/registration'
  }

  return (
    <section className={styles.holiday_main_section}>
      <div className={styles.promo_card}>
        <div className={styles.promo_card__content}>
          <h2 className={styles.promo_card__title}>Imagine Your Next Holiday FREE</h2>
          <p className={styles.promo_card__subtitle}>
            Share your travel stories and inspire others.
          </p>
          <button className={styles.promo_card__button} onClick={becomeATourMaster}>
            Become a Tour Master
            <span className={styles.promo_card__button_icon} aria-hidden="true">
              <img src="images/te_Arrow_right.svg" alt="Arrow Right" />
            </span>
          </button>
        </div>
        <div className={styles.promo_card__image}>
          <img
            src="images/holiday_bag.png"
            alt="Suitcase with hat"
            className={styles.promo_card__img}
          />
        </div>
      </div>
    </section>
  )
}
